module.exports = __webpack_public_path__ + "static/media/back.6f0497ba.svg";